import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './style.module.scss';
const version = document.querySelector('meta[name="app-version"]')?.getAttribute('content') ?? 'unknown';
const PageFooter = () => {
    return (_jsxs("p", { className: styles.footerContent, children: ["BeeyLive version ", version, " \u00A9 2022-", new Date().getFullYear(), " Beey by ", ' ', _jsx("a", { href: "http://www.newtontech.net", target: "_blank", rel: "noreferrer", children: "Newton Technologies" })] }));
};
export default PageFooter;
